'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));
var $ = _interopDefault(require('jquery'));

var templateRegexp = /%\{(.+?)\}/g;
var idCounter = 0;

/**
 * @class ShopifyMarketing.Fn
 */

/**
 * Given a `string` that may contain placeholders, replace them with
 * the values from the `data` object. Placeholders look like
 * `%{number_of_cats}`, which would be replaced by the key
 * `number_of_cats` in `data`. If a placeholder does not exist in
 * `data`, it will remain in the `string`.
 *
 * @method template
 * @param  {string} string
 * @param  {object} data
 * @return {string}
 *  String with placeholders replaced with values.
 */
function template(string, data) {
  var matches = string.match(templateRegexp);

  if (matches) {
    return matches.reduce(function (res, match) {
      var key = match.replace(/%{(.*)}/, '$1');
      if (data.hasOwnProperty(key)) {
        return res.replace(match, data[key]);
      }
      return res;
    }, string);
  }

  return string;
}

/**
 * Promisify a function using jQuery's Deferred. Note the returned
 * value is NOT an ES6 Promise. Obtain a real promise by calling
 * `.promise()` on the returned value.
 *
 * @method  promisify
 * @param  {function} fn
 * @param  {any}      thisArg
 * @return {Deferred}
 */
function promisify(fn, thisArg) {
  thisArg = thisArg || this; // eslint-disable-line no-param-reassign

  return function () {
    var dfr = $.Deferred();

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    dfr.resolve(fn.apply(thisArg, args));
    return dfr;
  };
}

/**
 * Debounce the given function, where it will only be called once until the
 * `wait` period has passed. `wait` is in milliseconds. The period can be
 * skipped by passing the third argument, `immediate` as `true`.
 *
 * @method  debounce
 * @param  {function} fn
 * @param  {integer}  wait
 * @param  {boolean}  immediate
 * @return {function}
 */
function debounce(fn, wait) {
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var timeout = void 0;

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var self = this;

    clearTimeout(timeout);

    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) {
        fn.apply(self, args);
      }
    }, wait);

    if (immediate && !timeout) {
      fn.apply(self, args);
    }
  };
}

/**
 * Throttle the given function to run at most once every `limit`, where `limit`
 * is in milliseconds.
 *
 * @method  throttle
 * @param  {function} fn
 * @param  {integer}  limit
 * @return {function}
 */
function throttle(fn, limit) {
  var wait = false;

  return function () {
    if (wait) {
      return;
    }

    fn.call();

    wait = true;
    setTimeout(function () {
      wait = false;
    }, limit);
  };
}

/**
 * Returns a jQuery object from a given URL hash, eg. `#element-1`. It is
 * expected the URL hash will be the ID attribute of an element.
 *
 * @method getJQueryObjectFromHash
 * @deprecated As jQuery is deprecated in MA, you should limit the usage of this
 *  function.
 * @param  {string} hash
 * @return {jQuery}
 */
function getJQueryObjectFromHash(hash) {
  var id = hash && hash.slice(1);

  return $(document.getElementById(id));
}

/**
 * Determine if the given value is an object.
 *
 * @method isObject
 * @param  {any}  value
 * @return {boolean}
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && type === 'object';
}

/**
 * Given a prefix, returns a unique string by incrementing an integer and
 * appending it to the prefix.
 *
 * @method isUnique
 * @param  {string} prefix
 * @return {string}
 */
function uniqueId(prefix) {
  ++idCounter;
  return '' + prefix + idCounter;
}

/**
 * Returns a function that ensures the given function can only called once.
 *
 * @method once
 * @param  {function} fn
 * @return {function}
 */
function once(fn) {
  var called = false;
  var result = void 0;

  return function () {
    if (!called) {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      result = fn.apply(this, args);
    }

    called = true;

    return result;
  };
}

/**
 * Determines if the given object is a jQuery object.
 *
 * @method isjQuery
 * @deprecated As jQuery is deprecated in MA, you should limit the usage of this
 *  function.
 * @param  {any}  obj
 * @return {boolean}
 */
function isJquery(obj) {
  return obj instanceof $;
}

var Fn = {
  template: template,
  promisify: promisify,
  debounce: debounce,
  throttle: throttle,
  getJQueryObjectFromHash: getJQueryObjectFromHash,
  isObject: isObject,
  uniqueId: uniqueId,
  once: once,
  isJquery: isJquery
};

exports.template = template;
exports.promisify = promisify;
exports.debounce = debounce;
exports.throttle = throttle;
exports.getJQueryObjectFromHash = getJQueryObjectFromHash;
exports.isObject = isObject;
exports.uniqueId = uniqueId;
exports.once = once;
exports.isJquery = isJquery;
exports.default = Fn;
